import { FormatArrivalTime } from "flights/lookup/FlightSearchResult";
import moment from "moment";
import React from "react";
import { formatTime, formatWrittenDayMonthYear } from "utilities";

interface Props {
  dateTime: server.dto.AppointmentDateTime
}

export const AppointmentDateTimeStart = (props: Props) => {
  const startDisplayMoment = moment.utc(props.dateTime.startDisplay);

  const inTheNightOf = props.dateTime.mode === "hasTimeStartsInNight";

  return <div>
    <div>{formatTime(startDisplayMoment)}</div>
    <div>
      {inTheNightOf ? `${RESX.DateTime.InTheNightOf} ` : null}
      {formatWrittenDayMonthYear(startDisplayMoment)}
    </div>
  </div>
}

export const AppointmentDateTimeEnd = (props: Props) => {
  const startDisplayMoment = moment.utc(props.dateTime.startDisplay);
  const endDisplayMoment = moment.utc(props.dateTime.endDisplay);

  return <FormatArrivalTime departure={startDisplayMoment} arrival={endDisplayMoment} />
}